export const collapsibleSection = () => {
  const collapsibleSection = ".js-collapsible-section";
  const collapsibleSectionToExpand = ".js-collapsible-section-to-expand";
  const collapsibleSectionToggle = ".js-collapsible-section-toggle";

  const init = () => {
    bind();
  };

  const bind = () => {
    function scrollToTargetAdjusted() {
      const element = document.querySelector(
        '.js-collapsible-section[data-state="open"]'
      );

      // Take the mobile's fixed header banner into account for scroll offset
      let offset = 0;
      if (window.innerWidth < 960) {
        offset = document.getElementById("header").offsetHeight;
      } else {
        offset = 0;
      }

      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }

    function closeSections() {
      const sections = document.querySelectorAll(collapsibleSection);
      sections.forEach((section) => {
        section.setAttribute("data-state", "closed");
      });

      const toExpandSections = document.querySelectorAll(
        collapsibleSectionToExpand
      );
      toExpandSections.forEach((section) => {
        section.style.height = "0";
      });
    }

    const toggles = document.querySelectorAll(collapsibleSectionToggle);
    toggles.forEach((toggle) => {
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        closeSections();

        const section = this.closest(collapsibleSection);
        const toExpand = section.querySelector(collapsibleSectionToExpand);

        const currentState = section.getAttribute("data-state");
        const newState = currentState === "closed" ? "open" : "closed";
        section.setAttribute("data-state", newState);

        if (newState === "open") {
          const contentHeight = section.querySelector(
            ".js-collapsible-section-content"
          ).offsetHeight;
          toExpand.style.height = `${contentHeight}px`;
          console.log(contentHeight);
        } else {
          toExpand.style.height = "0";
        }

        setTimeout(() => {
          scrollToTargetAdjusted();
        }, 360);
      });
    });
  };

  init();
};
